export const SETTINGS_TAB_IDS = [
  "general",
  "team",
  "passkeys",
  "features",
  "engine",
  "secrets",
  "connectors",
  "usage",
  "shortcuts",
] as const;

export type SettingsTabId = (typeof SETTINGS_TAB_IDS)[number];

/**
 * Display labels for the Settings tabs. Single source shared by the
 * settings-local nav and the command palette (RFC-004 R5.4 settings search).
 */
export const SETTINGS_TAB_LABELS: Record<SettingsTabId, string> = {
  general: "General",
  team: "Team & access",
  passkeys: "Passkeys",
  features: "Features",
  engine: "Engine",
  secrets: "Secrets & BYOK",
  connectors: "Connectors & keys",
  usage: "Usage & limits",
  shortcuts: "Related pages",
};

/**
 * Parse `?tab=` for Settings; defaults to general.
 */
export function parseSettingsTab(search: string | null): SettingsTabId {
  if (search && SETTINGS_TAB_IDS.includes(search as SettingsTabId)) {
    return search as SettingsTabId;
  }
  return "general";
}
